import { render, staticRenderFns } from "./DatabasePrivileges.vue?vue&type=template&id=5dd14866"
import script from "./DatabasePrivileges.vue?vue&type=script&lang=js"
export * from "./DatabasePrivileges.vue?vue&type=script&lang=js"
import style0 from "./DatabasePrivileges.vue?vue&type=style&index=0&id=5dd14866&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports